var map = {
	"./aia.svg": 1372,
	"./ant.svg": 1373,
	"./aus.svg": 1374,
	"./bah.svg": 1375,
	"./ban.svg": 1376,
	"./bar.svg": 1377,
	"./ber.svg": 1378,
	"./biz.svg": 1379,
	"./bot.svg": 1380,
	"./bru.svg": 1381,
	"./can.svg": 1382,
	"./cay.svg": 1383,
	"./cmr.svg": 1384,
	"./cok.svg": 1385,
	"./cyp.svg": 1386,
	"./dma.svg": 1387,
	"./eng.svg": 1388,
	"./fij.svg": 1389,
	"./flk.svg": 1390,
	"./gab.svg": 1391,
	"./gam.svg": 1392,
	"./ggy.svg": 1393,
	"./gha.svg": 1394,
	"./gib.svg": 1395,
	"./grn.svg": 1396,
	"./guy.svg": 1397,
	"./ind.svg": 1398,
	"./iom.svg": 1399,
	"./ivb.svg": 1400,
	"./jam.svg": 1401,
	"./jey.svg": 1402,
	"./ken.svg": 1403,
	"./kir.svg": 1404,
	"./lca.svg": 1405,
	"./les.svg": 1406,
	"./manifest.json": 767,
	"./mas.svg": 1407,
	"./maw.svg": 1408,
	"./mdv.svg": 1409,
	"./mlt.svg": 1410,
	"./moz.svg": 1411,
	"./mri.svg": 1412,
	"./msr.svg": 1413,
	"./nam.svg": 1414,
	"./nfk.svg": 1415,
	"./ngr.svg": 1416,
	"./nir.svg": 1417,
	"./niu.svg": 1418,
	"./nru.svg": 1419,
	"./nzl.svg": 1420,
	"./pak.svg": 1421,
	"./png.svg": 1422,
	"./rsa.svg": 1423,
	"./rwa.svg": 1424,
	"./sam.svg": 1425,
	"./sco.svg": 1426,
	"./sey.svg": 1427,
	"./sgp.svg": 1428,
	"./shn.svg": 1429,
	"./skn.svg": 1430,
	"./sle.svg": 1431,
	"./sol.svg": 1432,
	"./sri.svg": 1433,
	"./svg-country.svg": 1434,
	"./swz.svg": 1435,
	"./tan.svg": 1436,
	"./tca.svg": 1437,
	"./tga.svg": 1438,
	"./tog.svg": 1439,
	"./tto.svg": 1440,
	"./tuv.svg": 1441,
	"./uga.svg": 1442,
	"./van.svg": 1443,
	"./wal.svg": 1444,
	"./zam.svg": 1445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1371;